import { useTranslation } from 'react-i18next';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { useQuery } from '@tanstack/react-query';
import { getTenantGroupOverrides, ListNamesDictionary } from 'Services';
import { RQ_TENANT_GROUP_OVERRIDES, RQ_TENANT_GROUP_OVERRIDES_INHERITED } from 'Utils';
import { transformServerData } from '../helper';

interface TenantGroupOverrides {
    tenantGroupId?: string;
    users?: UsersHashmap;
    queryEnabled?: boolean;
    version?: number;
}

interface TenantGroupOverridesInherited extends TenantGroupOverrides {
    listNameMap?: ListNamesDictionary;
    parameterData?: UseGetParametersResponse;
}

export const useGetTenantGroupOverrides = ({ tenantGroupId, users, queryEnabled, version }: TenantGroupOverrides) => {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_TENANT_GROUP_OVERRIDES, tenantGroupId],
        () => getTenantGroupOverrides(templateRepositoryId!, false, version, tenantGroupId),
        {
            enabled: queryEnabled !== false && !!templateRepositoryId,
            select: transformServerData({ t, users })
        }
    );
};

export const useGetTenantGroupOverridesInherited = ({
    tenantGroupId,
    users,
    queryEnabled,
    version,
    listNameMap,
    parameterData
}: TenantGroupOverridesInherited) => {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_TENANT_GROUP_OVERRIDES_INHERITED, tenantGroupId],
        () => getTenantGroupOverrides(templateRepositoryId!, true, version, tenantGroupId),
        {
            enabled: queryEnabled !== false && !!templateRepositoryId,
            select: transformServerData({ t, users, listNameMap, parameterData })
        }
    );
};
